"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.objectToCSSVariables = void 0;
var other_1 = require("./other");
var getNormalizedValue = function (value) {
    if (Array.isArray(value)) {
        return value.map(function (val) { return val.origin; }).join(', ');
    }
    if (typeof value === 'object') {
        return value.origin;
    }
    return value;
};
/**
 * Преобразовать объект токенов в плоский объект,
 * где ключом выступает название CSS переменной, значением - значение переменной.
 * @param {object} obj
 * @param {string} prefix
 * @param {boolean?} withPrefixDesign
 * @param {boolean?} withKebabCase
 * @return {object}
 */
var objectToCSSVariables = function (obj, prefix, withPrefixDesign, withKebabCase) {
    if (prefix === void 0) { prefix = ''; }
    return Object.keys(obj)
        .filter(function (key) { return key !== 'modes' && key !== 'comment'; })
        .reduce(function (vars, key) {
        var name = (0, other_1.join)(prefix, key);
        var value = obj[key] || '';
        if (typeof value !== 'object' || 'origin' in value || Array.isArray(value)) {
            var newValue = getNormalizedValue(value);
            vars[(0, other_1.getCSSVariableName)(name, withPrefixDesign, withKebabCase)] = (0, other_1.escapeValue)(newValue);
            return vars;
        }
        vars = __assign(__assign({}, vars), (0, exports.objectToCSSVariables)(value, name, withPrefixDesign, withKebabCase));
        return vars;
    }, {});
};
exports.objectToCSSVariables = objectToCSSVariables;
//# sourceMappingURL=objectToCSSVariables.js.map